import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MaterialModule } from '../../material.module';

import { MatDialog } from '@angular/material/dialog';
import { UploadService } from '../../services/ upload.service';
import { Asset } from './asset.interface';
import { ImageCropperDialogComponent } from './components/image-cropper-dialog.component';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  imports: [MaterialModule, CommonModule],
})
export class FileUploadComponent implements OnChanges {
  @Input() asset: Asset | null = null; // initial asset from parent
  @Output() uploadSuccess = new EventEmitter<Asset | null>(); // emit on upload complete
  @Input() aspectRatio = 900 / 90;
  @Input() resizeToWidth = 900;

  uploadProgress: number | null = null;
  uploadResult: any = null;
  error: any = null;
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['asset']) {
      this.previewUrl = this?.asset?.url;
    }
  }

  constructor(
    private dialog: MatDialog,
    private uploadService: UploadService
  ) {}

  onFileSelected(event: any) {
    const fileInput = event.target as HTMLInputElement;

    const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
      width: window.innerWidth - 100 + 'px',
      height: window.innerHeight - 100 + 'px',
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        imageChangedEvent: event,
        aspectRatio: this.aspectRatio,
        resizeToWidth: this.resizeToWidth,
      },
    });

    dialogRef.afterClosed().subscribe((croppedImage: File | null) => {
      if (croppedImage) {
        this.uploadFile(croppedImage);
      } else {
        console.log('No cropped image available');
      }
      if (fileInput) {
        fileInput.value = '';
      }
    });
  }

  uploadFile(file: File): void {
    if (file) {
      this.selectedFile = file;
      this.error = null;
      this.uploadProgress = 0;
      this.uploadResult = null;

      // Show local preview immediately
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(this.selectedFile);

      const { progress$, done$ } = this.uploadService.startUpload(
        this.selectedFile
      );

      progress$.subscribe({
        next: (progress) => {
          this.uploadProgress = progress;
        },
        error: (err) => {
          this.error = err;
          this.uploadProgress = null;
        },
      });

      done$.subscribe({
        next: (result: Asset) => {
          this.uploadResult = result;
          this.uploadProgress = null;
          this.uploadSuccess.emit(result);
          this.previewUrl = result.url;
        },
        error: (err) => {
          this.error = err;
          this.uploadProgress = null;
        },
      });
    }
  }

  cancelUpload() {
    this.selectedFile = null;
    this.previewUrl = this.asset?.url || null;
    this.uploadResult = null;
    this.uploadProgress = null;
    this.uploadSuccess.emit(null);
    this.error = null;
  }

  triggerFileInput(fileInput: HTMLInputElement) {
    fileInput.click();
  }
}
